import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=7b689687&scoped=true"
var script = {}
import style0 from "./InfoBlock.vue?vue&type=style&index=0&id=7b689687&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b689687",
  null
  
)

export default component.exports